export default __webpack_public_path__ + "static/media/snapper.e29afa6d.png";